import PermissionRoles from '@constants/permission_roles'
import { PermissionRole } from '@app-types/general'

type RoleSelectOption = {
  text: string
  value: PermissionRole
}

export const getRoleSelectOptions = (): RoleSelectOption[] => {
  return [
    { text: 'Can view', value: PermissionRoles.VIEWER },
    { text: 'Can view & edit', value: PermissionRoles.EDITOR },
    { text: 'Can view, edit, and delete', value: PermissionRoles.ADMIN },
  ]
}
